/* istanbul ignore file */
import Carousel from './Carousel';

export default Carousel;
